import { render, staticRenderFns } from "./WavesAerialito.vue?vue&type=template&id=49c250e2&scoped=true&"
import script from "./WavesAerialito.vue?vue&type=script&lang=ts&"
export * from "./WavesAerialito.vue?vue&type=script&lang=ts&"
import style0 from "./WavesAerialito.vue?vue&type=style&index=0&id=49c250e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c250e2",
  null
  
)

export default component.exports